import { Bell } from "lucide-react";
import { NotificationItem } from "@/entities/notification/model/types";
import { isChat } from "../lib/notificationGroups";

const AVATAR_COLORS = [
    "bg-sky-100 text-sky-700 dark:bg-sky-500/20 dark:text-sky-300",
    "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300",
    "bg-amber-100 text-amber-800 dark:bg-amber-500/20 dark:text-amber-300",
    "bg-rose-100 text-rose-700 dark:bg-rose-500/20 dark:text-rose-300",
    "bg-violet-100 text-violet-700 dark:bg-violet-500/20 dark:text-violet-300",
    "bg-cyan-100 text-cyan-700 dark:bg-cyan-500/20 dark:text-cyan-300",
];

function avatarColor(str: string): string {
    let hash = 0;
    for (let i = 0; i < str.length; i++) hash = (hash * 31 + str.charCodeAt(i)) | 0;
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

function initials(str: string): string {
    const parts = str.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "?";
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function NotificationAvatar({ item }: { item: NotificationItem }) {
    if (isChat(item.type)) {
        return (
            <span className={`w-8 h-8 rounded-full flex items-center justify-center text-[11px] font-semibold flex-shrink-0 ${avatarColor(item.title)}`}>
                {initials(item.title)}
            </span>
        );
    }

    return (
        <span className="w-8 flex items-start justify-center flex-shrink-0 pt-0.5">
            <Bell size={20} className="text-dark_green dark:text-emerald-400" />
        </span>
    );
}
